export default __webpack_public_path__ + "navigation-examples-location-snapping-thumbnail-480-0abe342a47f5f016e036f71ba9c139f7.webp";